export default {
  BRAND_GOLD: '#A69256',
  BRAND_BLACK: '#000000',
  BRAND_GRAY: '#808080',
  LIGHT_GRAY: '#F5F5F5',
  ERROR: '#FA0000',
  BLUE: '#0202f7',
};
